import React from "react";
import { Component } from "react";
import SearchArea from "./SearchArea";
import BookList from "./BookList";
import BookInfo from "./BookInfo";
import request from 'superagent';

class BookArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            books: [],
            searchField: '',
            sort: '',
            currentBook: null
        }
    }

    searchBook = (e) => {
        e.preventDefault();
        console.log(this.state.searchField);
        if (this.state.searchField !== ""){
            request
            .get("https://www.googleapis.com/books/v1/volumes?q="+this.state.searchField+"&maxResults=40")
            .then((data) => {
                console.log(data);
                const cleanData = this.cleanData(data)
                this.setState({ books: cleanData})
            })
        }
    }

    //update state met wat er in het searchfield staat
    handleSearch = (e) => {
        console.log(e.target.value);
        this.setState({ searchField: e.target.value})
    }

    //clean data: voor als een book geen prop heeft en default value geven
    cleanData = (data) => {
        const cleanedData = data.body.items.map((book) =>{
            if(book.volumeInfo.hasOwnProperty('publishedDate') === false){
                book.volumeInfo['publishedDate'] = '0000';
            }
            
            else if(book.volumeInfo.hasOwnProperty('imageLinks') === false){
                book.volumeInfo['imageLinks'] = {thumbnail: 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg'}
            }

            return book;
        })

        return cleanedData;
    }

    viewBookInfo = (id) => {
        const filteredBook = this.state.books.filter(book => book.id === id)

        const newCurrentBook = filteredBook.length > 0 ? filteredBook[0] : null

        this.setState({ currentBook: newCurrentBook })
    }

    closeBookInfo = () => {
        this.setState({currentBook: null})
    }

    render(){
        return (
            <div>
                <h1 className="pageTitle">Search books</h1>
                {this.state.currentBook === null ? 
                <div> 
                <SearchArea searchBook={this.searchBook} handleSearch={this.handleSearch} handleSort={this.handleSort} />
                <BookList viewBookInfo={this.viewBookInfo} books={this.state.books}/>
                </div>
                : <BookInfo currentBook={this.state.currentBook} closeBookInfo={this.closeBookInfo}/>}            
            </div>
        );
    }
}

export default BookArea;

